import {
  BrsApi,
  ClippServiceApi,
  ConfigApi,
  Configuration,
  CRMCHLinkApi,
  DocumentsApi,
  EamEfaDashboardServiceApi,
  EmployeeApi,
  LookupConfigApi,
  MemberZoneApi,
  PartnersApi,
  PortfolioApi,
  ProductCatalogueApi,
  ProductsAndServicesApi,
  ProfilingWizardApi,
  ServiceAgreementApi,
  ServiceRoleApi,
  TaskApi,
  VideoIdentificationServiceApi,
} from 'pco-product-service-internal-consumer';
import { REACT_APP_API_URL } from 'services/constants';

const configuration = new Configuration({
  basePath: `${REACT_APP_API_URL}/api/v1`,
});

export const serviceAgreementApi = new ServiceAgreementApi(configuration);
export const partnersApi = new PartnersApi(configuration);
export const serviceRoleApi = new ServiceRoleApi(configuration);
export const productCatalogueApi = new ProductCatalogueApi(configuration);
export const crmchLinkApi = new CRMCHLinkApi(configuration);
export const taskApi = new TaskApi(configuration);
export const brsApi = new BrsApi(configuration);
export const productsAndServicesApi = new ProductsAndServicesApi(configuration);
export const documentsApi = new DocumentsApi(configuration);
export const memberZoneApi = new MemberZoneApi(configuration);
export const videoIdentificationApi = new VideoIdentificationServiceApi(configuration);
export const configApi = new ConfigApi(configuration);
export const clippApi = new ClippServiceApi(configuration);
export const eamEfaDashboardApi = new EamEfaDashboardServiceApi(configuration);
export const portfolioApi = new PortfolioApi(configuration);
export const profilingWizardApi = new ProfilingWizardApi(configuration);
export const lookupConfig = new LookupConfigApi(configuration);
export const employeeApi = new EmployeeApi(configuration);
